<!-- <p>form-field-button works!</p> -->
<div class="top_24">
<button *ngIf="configData.type === 'reset' " type="{{configData.type}}" (click)="resetBtnClick()" title="{{configData['toolTip']}}"
mat-stroked-button color="warn" [class]="configData.label === 'Get User Details' ? 'dhl-button dhl-button-text' : 'dhl-button'">{{configData.label}}</button>
<button *ngIf="configData.type === 'submit' " type="{{configData.type}}" title="{{configData['toolTip']}}" (click)="submitBtnClick()"
mat-raised-button color="warn" [class]="configData.label=== 'Get User Details' ? 'dhl-button dhl-button-text' : 'dhl-button'">{{configData.label}}</button>
<!-- <button  type="button"
(click)="navigateTo(pageAction.command.redirectUrl)"
class="btn buttons-secondary dhl-button-v2">{{pageAction.view.label}}</button> -->
</div>

